export const GENERAL_ERROR = 1;
export const BAD_CREDENTIALS_ERROR = 2;
export const TOKEN_ABSENT_ERROR = 3;
export const TOKEN_EXPIRED_ERROR = 4;
export const TOKEN_INVALID_ERROR = 5;
export const INACTIVE_USER = 6;
